import React, { useState } from 'react';
import MarkdownRenderer from '../MarkdownRenderer';
import './TabStyles.css';

const MultiPerspectiveTab = ({ candidate }) => {
    const [activePerspective, setActivePerspective] = useState('cto');

    // Get multi-perspective analysis
    // Check multiple locations for summary_perspectives (matching AdvancedAnalysis.js logic):
    // 1. analysis.summary_perspectives (legacy format - most common)
    // 2. rag_analysis.summary_perspectives (if stored directly in rag_analysis)
    // 3. Parse rag_analysis if it's a JSON string
    const getPerspectives = () => {
        // Parse rag_analysis if it's a string
        let parsedRagAnalysis = candidate.rag_analysis;
        if (typeof candidate.rag_analysis === 'string') {
            try {
                parsedRagAnalysis = JSON.parse(candidate.rag_analysis);
            } catch (e) {
                console.warn('[MultiPerspectiveTab] Failed to parse rag_analysis as JSON:', e);
                parsedRagAnalysis = null;
            }
        }
        
        // Check all possible locations
        const summaryPerspectives = candidate.analysis?.summary_perspectives 
            || parsedRagAnalysis?.summary_perspectives 
            || candidate.rag_analysis?.summary_perspectives;
        
        if (summaryPerspectives) {
            return {
                cto: summaryPerspectives.cto_perspective,
                hr: summaryPerspectives.hr_perspective,
                ceo: summaryPerspectives.ceo_perspective
            };
        }
        
        return null;
    };

    const perspectives = getPerspectives();

    return (
        <div className="tab-content multi-perspective-tab">
            <h2 className="section-header">FIT ASSESSMENT</h2>
            
            {perspectives ? (
                <>
                    <div className="perspective-section">
                        <p className="section-description">
                            View this candidate from different stakeholder perspectives to make a well-informed decision.
                        </p>
                        
                        <div className="perspectives-tabs">
                            <button
                                className={`perspective-tab ${activePerspective === 'cto' ? 'active' : ''}`}
                                onClick={() => setActivePerspective('cto')}
                            >
                                CTO
                            </button>
                            <button
                                className={`perspective-tab ${activePerspective === 'hr' ? 'active' : ''}`}
                                onClick={() => setActivePerspective('hr')}
                            >
                                HR
                            </button>
                            <button
                                className={`perspective-tab ${activePerspective === 'ceo' ? 'active' : ''}`}
                                onClick={() => setActivePerspective('ceo')}
                            >
                                CEO
                            </button>
                        </div>
                        
                        <div className="perspective-content">
                            {perspectives[activePerspective] ? (
                                <MarkdownRenderer text={perspectives[activePerspective]} />
                            ) : (
                                <p className="no-data-text">No {activePerspective.toUpperCase()} perspective available.</p>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <div className="no-data-message">
                    <p>Multi-perspective analysis not available for this candidate.</p>
                </div>
            )}
        </div>
    );
};

export default MultiPerspectiveTab;
